"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var packageJson = require('../package.json');

exports.packageInfo = {
  name: packageJson.name,
  version: packageJson.version
};
exports.default = exports.packageInfo;